import { h, createContext } from 'preact'
import { useContext, useReducer } from 'preact/hooks'

/** @jsx h */
export const StateContext = createContext()
export const StateProvider = ({ reducer, initialState, children }) => (
  <StateContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </StateContext.Provider>
)
export const useAppState = () => useContext(StateContext)



// WEBPACK FOOTER //
// ./src/js/quiz/state/Quiz.context.jsx